import { Pagination } from "antd";
import { FC } from "react";

interface paginationProps {
    total: number;
    callback: (page: number, pageSize?: number) => void;
    defaultPageSize?: number;
    defaultCurrent?: number;
    pageSize?: number;
    current?: number;
}

const Paginations: FC<paginationProps> = ({ total, callback, defaultPageSize, defaultCurrent, pageSize: controlledPageSize, current: controlledCurrent }) => {

    const pageSize = typeof controlledPageSize === 'number' ? controlledPageSize : defaultPageSize;
    const current = typeof controlledCurrent === 'number' ? controlledCurrent : defaultCurrent;

    return (
        <div className={`pagination`}>
           { total > 0 && <Pagination
                align="end"
                total={total}
                showSizeChanger
                pageSize={pageSize}
                current={current}
                onChange={(page, newPageSize) => callback(page, newPageSize)}
                pageSizeOptions={[5, 10, 25, 50]}
                showLessItems
            />}
        </div>
    )
}

export default Paginations;